import _ from 'lodash';
import React, { useState } from 'react';
import { Field } from 'react-final-form';
import ComboBoxAutocomplete from '../../FormFields/ComboBoxAutocomplete';
import Divider from '@mui/material/Divider';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Button, FieldError } from '@/ui';
import { TabPane } from '../TabPane';
import { useHandlers } from '../../../views/OfferBlocks/queries';
import { Condition, SelectField, ToggleSwitchRow } from '../../FinalForm';
import { InternalPrePings } from './InternalPrePings';

const PrePingPane = ({ collapse, source }) => {
  const generateName = (field) => (source ? `${source}.${field}` : field);
  const { data: handlers } = useHandlers(collapse, (data) => _.orderBy(data, ['name'], ['asc']));
  const [advancedSettings, setAdvancedSettings] = useState(false);

  return (
    <TabPane tabId='Pre-ping'>
      <Grid container spacing={2} sx={{ alignItems: 'start' }}>
        <Grid size='grow'>
          <InternalPrePings source={source} />
        </Grid>
        {source !== 'publisherPrePingCriteria' && (
          <>
            <Grid size='grow'>
              <div>
                <Grid container spacing={2} sx={{ alignItems: 'start' }}>
                  <Grid size='grow'>
                    <Typography variant='h5'>External Pre-Ping</Typography>
                  </Grid>
                </Grid>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2} sx={{ alignItems: 'start' }}>
                  <Grid size='grow'>
                    <ToggleSwitchRow
                      name={generateName('prePingResultSessionCapture')}
                      label='Pre-Ping Result Stored'
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ alignItems: 'start' }}>
                  <Grid size='grow'>
                    <ToggleSwitchRow
                      name={generateName('advancedExternalPrepingEnabled')}
                      label='Advanced Pre Ping Enabled'
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ alignItems: 'start' }}>
                  <Grid size='grow'>
                    <FormLabel component='span' sx={{ display: 'block', mb: 0.5 }}>
                      Pre Ping Method
                    </FormLabel>
                    <SelectField
                      name={generateName('prePingMethod')}
                      options={[
                        { value: '', option: 'Select method...' },
                        { value: 'GET', option: 'GET' },
                        { value: 'POST', option: 'POST' },
                        { value: 'JSON', option: 'JSON' },
                        { value: 'XML', option: 'XML' },
                      ]}
                    />
                  </Grid>
                  <Grid size='grow'>
                    <FormLabel component='span' sx={{ display: 'block', mb: 0.5 }}>
                      Handler
                    </FormLabel>
                    <Field name={generateName('prePingHandlerId')}>
                      {({ input, meta }) => (
                        <>
                          <ComboBoxAutocomplete
                            name={input.name}
                            options={handlers}
                            value={input.value}
                            onChange={(value) => input.onChange(value)}
                            onBlur={input.onBlur}
                            textField='name'
                            error={Boolean(meta.touched && meta.error)}
                          />
                          <FieldError error={meta.error} touched={meta.touched} />
                        </>
                      )}
                    </Field>
                  </Grid>
                </Grid>
                <Condition when={generateName('prePingMethod')} is={['GET', 'POST', 'JSON', 'XML']}>
                  <br />
                  <Grid container spacing={2} sx={{ alignItems: 'start' }}>
                    <Grid size='grow'>
                      <FormLabel component='span' sx={{ display: 'block', mb: 0.5 }}>
                        URL
                      </FormLabel>
                      <Field name={generateName('prePing')}>
                        {({ input }) => <TextField {...input} type='text' placeholder='URL' />}
                      </Field>
                    </Grid>
                  </Grid>
                  <Condition when={generateName('prePingMethod')} is={['POST', 'JSON', 'XML']}>
                    <Grid container spacing={2} sx={{ alignItems: 'start' }}>
                      <Grid size='grow'>
                        <FormLabel component='span' sx={{ display: 'block', mb: 0.5 }}>
                          Body
                        </FormLabel>
                        <Field name={generateName('prePingBody')}>
                          {({ input }) => <TextField {...input} multiline minRows={3} placeholder='Body' />}
                        </Field>
                      </Grid>
                    </Grid>
                  </Condition>
                  <Grid container spacing={2} sx={{ alignItems: 'start' }}>
                    <Grid size='grow' sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <Button onClick={() => setAdvancedSettings(!advancedSettings)}>
                        <em>advanced settings</em>
                      </Button>
                    </Grid>
                  </Grid>
                  <br />
                  {advancedSettings && (
                    <div>
                      <br />
                      <Grid container spacing={2} sx={{ alignItems: 'start' }}>
                        <Grid size={{ xs: 12, lg: 3 }}>
                          <Field name={generateName('prePingTimeout')}>
                            {({ input }) => <TextField {...input} type='number' placeholder='Timeout (ms)' />}
                          </Field>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{ alignItems: 'start' }}>
                        <Grid size='grow'>
                          <Field name={generateName('prePingHeader1')}>
                            {({ input }) => <TextField {...input} type='text' placeholder='Header 1' />}
                          </Field>
                        </Grid>
                        <Grid size='grow'>
                          <Field name={generateName('prePingHeader2')}>
                            {({ input }) => <TextField {...input} type='text' placeholder='Header 2' />}
                          </Field>
                        </Grid>
                        <Grid size='grow'>
                          <Field name={generateName('prePingHeader3')}>
                            {({ input }) => <TextField {...input} type='text' placeholder='Header 3' />}
                          </Field>
                        </Grid>
                      </Grid>
                      <br />
                      <Grid container spacing={2} sx={{ alignItems: 'start' }}>
                        <Grid size='grow'>
                          <Field name={generateName('prePingCustomHttpStatus')}>
                            {({ input }) => <TextField {...input} type='text' placeholder='HTTP Status' />}
                          </Field>
                        </Grid>
                      </Grid>
                    </div>
                  )}
                </Condition>
              </div>
            </Grid>
          </>
        )}
      </Grid>
    </TabPane>
  );
};

export default PrePingPane;
